import React, { Component } from 'react';
import './About.css';

export default class About extends Component {

  componentDidMount() {
    this.props.heightUpdate(this.divElement.clientHeight);
  }

  render() {
    return(
      <div id="about-container" className="about-container" ref={divElement => this.divElement = divElement}>
        <div className='about-text-section'>
          <h1 className='about-title'>ABOUT</h1>
          <div className='about-text'>
            <div className='about-text-desc'>
              <h2 className='about-text-strong'>
              I'm Andy Liang, a college student from New York who loves technology, dance, and music.
              </h2>
              <h2>
              Currently, I'm a Master's student at Stony Brook University studying Computer Science and doing research in cybersecurity.
              </h2> 
              <h2>
              I graduated from Stony Brook University with my Bachelor's last year, double majoring in Computer Science and Applied Mathematics &amp; Statistics.
              </h2>
              <h2>
              I've worked on projects using various client-side and server-side tools while also integrating various research topics such as distributed systems, big data, and machine learning.
              </h2>
              <h2>
              In my free time, I enjoy learning new skills, dancing, playing the piano, and working out.
              </h2>
            </div>
            <div className='about-text-skills'>
              <h2 className='about-text-strong'>I've worked with: </h2>
              <div className='about-text-skill-group'>
                <h2 className='about-text-skill-label'>Front-end:</h2>
                <div>
                  <h2>HTML5, CSS3, JavaScript ES6</h2>
                  <h2>React, React Native, Angular, D3.js</h2>
                </div>
              </div>
              <div className='about-text-skill-group'>
                <h2 className='about-text-skill-label'>Back-end:</h2>
                <div>
                  <h2>Python, Kotlin, Java, JavaFX, Golang</h2>
                  <h2>C, C#, C++, MIPS Assembly</h2>
                  <h2>Node.js, Express, Spring</h2>
                </div>
              </div>
              <div className='about-text-skill-group'>
                <h2 className='about-text-skill-label'>Database:</h2>
                <div>
                  <h2>MySQL, MongoDB, Mongoose</h2>
                  <h2>Elasticsearch, Cassandra</h2>
                </div>
              </div>
              <div className='about-text-skill-group'>
                <h2 className='about-text-skill-label'>Server/Cloud:</h2>
                <div>
                  <h2>Nginx, Apache, Ansible</h2>
                  <h2>RabbitMQ, Memcached</h2>
                </div>
              </div>
              <div className='about-text-skill-group'>
                <h2 className='about-text-skill-label'>Security:</h2>
                <div>
                  <h2>Megasploit, Wireshark, Ghidra</h2>
                </div>
              </div>
              <div className='about-text-skill-group'>
                <h2 className='about-text-skill-label'>Other:</h2>
                <div>
                  <h2>PySpark, Git, Heroku, LaTeX</h2>
                </div>
              </div>
              {/*<div>
                <h2 className='about-text-strong'>I've taken courses in:</h2>
                <h2>Machine Learning, Computer System Fundamentals, Theory of Computation, Computer Networks, Objected-Oriented Programming</h2>
              </div>
              <div>
                <h2 className='about-text-strong'>I'm currently studying:</h2>
                <h2>Operating Systems, Computer Security Fundamentals, Algorithms</h2>
              </div>*/}
            </div>
          </div>
        </div>
        <div className='about-image-section'>
          
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/About/About.js